const ISO_DATE = /^(\d{4})-(\d{2})-(\d{2})/;
const DATE_LOCALE = 'en-US';

export function parseDate(dateString: string): Date {
	const match = ISO_DATE.exec(dateString);

	if (match) {
		return new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3]));
	}

	return new Date(dateString);
}

export function formatDate(dateString: string): string {
	return parseDate(dateString).toLocaleDateString(DATE_LOCALE, {
		year: 'numeric',
		month: 'short',
		day: 'numeric'
	});
}

export function formatDateLong(dateString: string): string {
	return parseDate(dateString).toLocaleDateString(DATE_LOCALE, {
		year: 'numeric',
		month: 'long',
		day: 'numeric'
	});
}

export function getDateParts(dateString: string): { year: string; month: string; day: string } {
	const date = parseDate(dateString);

	return {
		year: String(date.getFullYear()),
		month: date.toLocaleDateString(DATE_LOCALE, { month: 'short' }),
		day: String(date.getDate())
	};
}
